import React, { useEffect, useState } from "react";
import "./Setting_Center.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Tab_list from "../Common/Common_Component/Tab_list/Tab_list";
import Change_Nickname_modal from "../Common/Common_Component/Common_Modal/Change_Nickname_modal/Change_Nickname_modal";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthLogin } from "../../features/auth/Slice";
import { IDS } from "../../utils/IDS";
import { useForm } from "react-hook-form";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import Change_Profile_modal from "../Common/Common_Component/Common_Modal/Change_Profile_modal/Change_Profile_modal";

function Setting_Center() {
  const tabListData = [
    {
      type: "link",
      name: "Login Password",
      image: "/assets/images/icons/lock_box.png",
      link: "/change-password",
    },
    {
      type: "link",
      name: "Bind Mailbox",
      image: "/assets/images/icons/mail_box.png",
      link: "/bind-mailbox",
    },
  ];
  const {
    control,
    register,
    resetField, reset,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      contact_no: "",
      email: "",
      password: "",
    },
  });
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowPic, setModalShowPic] = React.useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const [modalMessage, setModalMessage] = useState("Suceesfull");


  const dispatch = useDispatch()
  const user = useSelector((state => state.auth));

  useEffect(() => { dispatch(GETAuthLogin()) }, [dispatch]);
  useEffect(() => { reset(user?.data) }, [dispatch]);



  return (
    <>
      <section className="Setting_Center">
        <Common_white_header headingText={"Setting Center"} />

        <div className="container">
          {/* PROFILE CARD */}
          <div className="profile_card">
            <div className="profile_holder">
              <div className="img_holder">
                <img
                  src={user?.data?.profile_pic ? IDS.IMG_URL + user?.data?.profile_pic : "https://i.pravatar.cc/100"}
                  alt="profile"
                  className="profile_img"
                />
              </div>

              <div className="profile_action" onClick={() => setModalShowPic(true)}>
                Change Profile
                <span className="arrow">›</span>
              </div>
            </div>

            <div className="profile_info">
              <div className="nickname_row">
                <span className="label">Nickname</span>
                <span className="value" onClick={() => setModalShow(true)}>{user?.data?.name || ""} <FontAwesomeIcon icon={faChevronRight} /></span>
              </div>

              <div className="uid_row">
                <span className="label">UID</span>
                <span className="value">{user?.data?.user_uid || ""} <FontAwesomeIcon icon={faChevronRight} /></span>
              </div>
            </div>
          </div>

          <Tab_list listItems={tabListData} />
        </div>
      </section>
      <Change_Nickname_modal
        user={user?.data}
        register={register}
        show={modalShow}
        setModalMessage={setModalMessage}
        setModalShow1={setModalShow1}
        onHide={() => setModalShow(false)}
      />

      <Change_Profile_modal
        user={user?.data}
        register={register}
        show={modalShowPic}
        setModalMessage={setModalMessage}
        setModalShow1={setModalShow1}
        onHide={() => setModalShowPic(false)}
      />

      <Successfull_strip_modal
        show={modalShow1}
        onHide={() => setModalShow1(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Setting_Center;
